/**
 * 系统入口接口模块
 */

import { request } from '../request'
import type { User } from './system/user/index'
/**
 * @description 路由数据结构
 * @property {string} permissionId 权限id
 * @property {string} parentId 父级权限id
 * @property {string} permissionType 权限类型
 * @property {number} sortNum 排序
 * @property {string} path 路由路径
 * @property {string} name 路由名称
 * @property {string} component 组件路径
 * @property {string} redirect 重定向
 * @property {Router[]} children 子级路由
 * @property {Record<string, any>} meta 路由元信息
 */
export interface Router {
    permissionId: string
    parentId: string
    permissionType: PermissionType
    sortNum: number
    path: string
    name: string
    component: string
    redirect: string
    children: Router[]
    meta: Record<string, any>
}
/**
 * @description 路由树结构
 */
export type RouterRes = Router[]
/**
 * @description 获取路由树结构
 * @param {boolean} hasButton 是否包含按钮权限
 * @param {PermissionType[]} permissionTypes 权限类型
 */
export interface RouterTreeReq {
    hasButton?: boolean
}
/**
 * @description 获取路由列表
 * @param {PermissionType[]} permissionTypes 权限类型
 * @param {string} permissionCode 权限编码
 * @param {boolean} hasButton 是否包含按钮权限
 */
export interface RouterListReq {
    permissionTypes?: PermissionType[]
    permissionCode?: string
    hasButton?: boolean
}
/**
 * /routes/tree 替换 /menus/route
 * @description 获取路由树结构
 * @param {RouterRes} RouterRes - 路由树结构
 */
export const getRoutersTree = (params: RouterTreeReq) => {
    return request.get<Res<RouterRes>>({
        url: '/menus/route',
        params,
        needPremission: true,
        needLoading: true
    })
}

export interface LoginRes {
    token: string
    userId: string
    username: string
}
/**
 * 登录
 */
export const login = (params: string) => {
    return request.post<Res<LoginRes>>({
        url: '/login',
        data: params,
        needPremission: false,
        needLoading: false,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}

/**
 * 获取登录用户详情
 * @returns
 */
export const userInfo = () => {
    return request.get<Res<User>>({
        url: '/users/current',
        needPremission: true,
        needLoading: false
    })
}

/**
 * 退出登录
 * @returns
 */
export const loginOut = () => {
    return request.post<Res<any>>({
        url: '/logout',
        needPremission: true,
        needLoading: true
    })
}

/**
 * 获取验证码
 */
export const getCode = (params: string) => {
    return request.get<Res<any>>({
        url: `/captcha?key=${params}`,
        needPremission: false,
        needLoading: false,
        responseType: 'arraybuffer'
    })
}
